export default __webpack_public_path__ + "images/55c36e3b426b995a503d0b27bdbce221-holiday.webp";